import { cancelOrder, setAdAgree } from '../../../actions';
import { identityPayload, createReducer, forAction } from '../../../utils';

const initialState = false;

export default createReducer(
  [forAction(setAdAgree, identityPayload)],
  initialState,
  [cancelOrder],
);
